// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/requestcatalog/v1/requestcatalogmanagement.proto" (package "c1.api.requestcatalog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { UserRef } from "../../user/v1/user";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { User } from "../../user/v1/user";
import { AppEntitlementView } from "../../app/v1/app_entitlement";
import { AppEntitlementExpandMask } from "../../app/v1/app_entitlement";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { RequestCatalog } from "./requestcatalog";
import { RequestCatalogUnenrollmentEntitlementBehavior } from "./requestcatalog";
import { RequestCatalogUnenrollmentBehavior } from "./requestcatalog";
import { RequestCatalogEnrollmentBehavior } from "./requestcatalog";
import { Any } from "../../../../google/protobuf/any";
import { RequestCatalogView } from "./requestcatalog";
import { RequestCatalogExpandMask } from "./requestcatalog";
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequest
 */
export interface RequestCatalogManagementServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 2;
     */
    expandMask?: RequestCatalogExpandMask;
}
/**
 * The request catalog management service get response returns a request catalog view with the expanded items in the expanded array indicated by the expand mask in the request.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetResponse
 */
export interface RequestCatalogManagementServiceGetResponse {
    /**
     * A view of the request catalog, contains the serialized user and paths to objects referenced by the request catalog.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogView request_catalog_view = 1;
     */
    requestCatalogView?: RequestCatalogView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * Create a request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequest
 */
export interface RequestCatalogManagementServiceCreateRequest {
    /**
     * The display name of the new request catalog.
     *
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * The description of the new request catalog.
     *
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * The expand mask includes the paths in the catalog view to expand in the return value of this call.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 4;
     */
    expandMask?: RequestCatalogExpandMask;
    /**
     * Whether or not the new catalog should be created as published.
     *
     * @generated from protobuf field: bool published = 5;
     */
    published: boolean;
    /**
     * Whether or not the new catalog is visible to everyone by default.
     *
     * @generated from protobuf field: bool visible_to_everyone = 6;
     */
    visibleToEveryone: boolean;
    /**
     * Whether all the entitlements in the catalog can be requests at once. Your tenant must have the bundles feature to use this.
     *
     * @generated from protobuf field: bool request_bundle = 7;
     */
    requestBundle: boolean;
    /**
     * Defines how to handle the request policies of the entitlements in the catalog during enrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior enrollment_behavior = 8;
     */
    enrollmentBehavior: RequestCatalogEnrollmentBehavior;
    /**
     * Defines how to handle the revocation of the entitlements in the catalog during unenrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior unenrollment_behavior = 9;
     */
    unenrollmentBehavior: RequestCatalogUnenrollmentBehavior;
    /**
     * Defines how to handle the revoke policies of the entitlements in the catalog during unenrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior unenrollment_entitlement_behavior = 10;
     */
    unenrollmentEntitlementBehavior: RequestCatalogUnenrollmentEntitlementBehavior;
}
/**
 * Update a request catalog object by ID.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateRequest
 */
export interface RequestCatalogManagementServiceUpdateRequest {
    /**
     * The request catalog to update values with.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalog catalog = 1;
     */
    catalog?: RequestCatalog;
    /**
     * The update mask is a comma-separated list of strings indicating what fields to update the request catalog with.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * The expand mask includes the paths in the catalog view to expand in the return value of this call.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 3;
     */
    expandMask?: RequestCatalogExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListRequest
 */
export interface RequestCatalogManagementServiceListRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The page_token field for pagination.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 3;
     */
    expandMask?: RequestCatalogExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListResponse
 */
export interface RequestCatalogManagementServiceListResponse {
    /**
     * The list of request catalogs.
     *
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogView list = 1;
     */
    list: RequestCatalogView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * The RequestCatalogManagementServiceAddAppEntitlementsRequest object is used to add app requestable app entitlements to a request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsRequest
 */
export interface RequestCatalogManagementServiceAddAppEntitlementsRequest {
    /**
     * The Id of the request catalog to add app entitlements to. This is a URL value.
     *
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * List of entitlements to add to the request catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 2;
     */
    appEntitlements: AppEntitlementRef[];
    /**
     * Whether or not to create requests for newly added entitlements for users in the catalog.
     * By default, this is false and no requests are created.
     *
     * @generated from protobuf field: bool create_requests = 3;
     */
    createRequests: boolean;
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsResponse
 */
export interface RequestCatalogManagementServiceAddAppEntitlementsResponse {
}
/**
 * The RequestCatalogManagementServiceUpdateAppEntitlementsRequest object is used to update app entitlements to a request catalog id.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsRequest
 */
export interface RequestCatalogManagementServiceUpdateAppEntitlementsRequest {
    /**
     * The Id of the request catalog to get app entitlement to. This is a URL value.
     *
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * The entitlement to get from the request catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 2;
     */
    appEntitlements: AppEntitlementRef[];
}
/**
 * The RequestCatalogManagementServiceUpdateAppEntitlementsResponse object is is the response from UpdateAppEntitlements endpoint.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsResponse
 */
export interface RequestCatalogManagementServiceUpdateAppEntitlementsResponse {
}
/**
 * The RequestCatalogManagementServiceRemoveAppEntitlementsRequest message is used to remove app entitlements from a request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsRequest
 */
export interface RequestCatalogManagementServiceRemoveAppEntitlementsRequest {
    /**
     * The catalogId for the catalog to remove entitlements from.
     *
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * The list of app entitlements to remove from the catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 2;
     */
    appEntitlements: AppEntitlementRef[];
}
/**
 * Empty response with a status code indicating success
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsResponse
 */
export interface RequestCatalogManagementServiceRemoveAppEntitlementsResponse {
}
// Individual Requestable Entry Management Messages

/**
 * Create a single requestable entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryRequest
 */
export interface RequestCatalogManagementServiceCreateRequestableEntryRequest {
    /**
     * The ID of the access profile (catalog) to add the entitlement to
     *
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * The ID of the app that contains the entitlement
     *
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * The ID of the entitlement to add to the request catalog
     *
     * @generated from protobuf field: string entitlement_id = 3;
     */
    entitlementId: string;
    /**
     * Whether or not to create requests for newly added entitlement for users in the catalog.
     * By default, this is false and no requests are created.
     *
     * @generated from protobuf field: bool create_requests = 4;
     */
    createRequests: boolean;
}
/**
 * A requestable entry in a catalog
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestableEntry
 */
export interface RequestableEntry {
    /**
     * The ID of the access profile (catalog)
     *
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * The ID of the app that contains the entitlement
     *
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * The ID of the entitlement
     *
     * @generated from protobuf field: string entitlement_id = 3;
     */
    entitlementId: string;
}
/**
 * Response containing the created requestable entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryResponse
 */
export interface RequestCatalogManagementServiceCreateRequestableEntryResponse {
    /**
     * The created requestable entry
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestableEntry requestable_entry = 1;
     */
    requestableEntry?: RequestableEntry;
}
/**
 * Get a single requestable entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryRequest
 */
export interface RequestCatalogManagementServiceGetRequestableEntryRequest {
    /**
     * The ID of the access profile (catalog)
     *
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * The ID of the app that contains the entitlement
     *
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * The ID of the entitlement
     *
     * @generated from protobuf field: string entitlement_id = 3;
     */
    entitlementId: string;
}
/**
 * Response containing the requested entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryResponse
 */
export interface RequestCatalogManagementServiceGetRequestableEntryResponse {
    /**
     * The requested entry
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestableEntry requestable_entry = 1;
     */
    requestableEntry?: RequestableEntry;
}
/**
 * Delete a single requestable entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryRequest
 */
export interface RequestCatalogManagementServiceDeleteRequestableEntryRequest {
    /**
     * The ID of the access profile (catalog)
     *
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * The ID of the app that contains the entitlement
     *
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * The ID of the entitlement
     *
     * @generated from protobuf field: string entitlement_id = 3;
     */
    entitlementId: string;
}
/**
 * Empty response for delete operation
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryResponse
 */
export interface RequestCatalogManagementServiceDeleteRequestableEntryResponse {
}
/**
 * The RequestCatalogManagementServiceAddAccessEntitlementsRequest message is used to add access entitlements to a request
 * catalog to determine which users can view the request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsRequest
 */
export interface RequestCatalogManagementServiceAddAccessEntitlementsRequest {
    /**
     * The Id of the request catalog to add access entitlements to. This is a URL value.
     *
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * List of entitlements to add to the request catalog as access entitlements.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef access_entitlements = 2;
     */
    accessEntitlements: AppEntitlementRef[];
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsResponse
 */
export interface RequestCatalogManagementServiceAddAccessEntitlementsResponse {
}
/**
 * The RequestCatalogManagementServiceRemoveAccessEntitlementsRequest message is used to remove access entitlements from a request catalog.
 * The access entitlements are used to determine which users can view the request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsRequest
 */
export interface RequestCatalogManagementServiceRemoveAccessEntitlementsRequest {
    /**
     * The catalogId for the catalog to remove access entitlements from.
     *
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * The list of access entitlements to remove from the catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef access_entitlements = 2;
     */
    accessEntitlements: AppEntitlementRef[];
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsResponse
 */
export interface RequestCatalogManagementServiceRemoveAccessEntitlementsResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogRequest
 */
export interface RequestCatalogManagementServiceListEntitlementsPerCatalogRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The RequestCatalogManagementServiceListEntitlementsPerCatalogResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogResponse
 */
export interface RequestCatalogManagementServiceListEntitlementsPerCatalogResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1;
     */
    list: AppEntitlementView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest
 */
export interface RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse
 */
export interface RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 1;
     */
    refs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppRequest
 */
export interface RequestCatalogManagementServiceListEntitlementsPerAppRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppResponse
 */
export interface RequestCatalogManagementServiceListEntitlementsPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1;
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessRequest
 */
export interface RequestCatalogManagementServiceListEntitlementsForAccessRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The RequestCatalogManagementServiceListEntitlementsForAccessResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessResponse
 */
export interface RequestCatalogManagementServiceListEntitlementsForAccessResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1;
     */
    list: AppEntitlementView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * Delete a request catalog by Id. It uses URL value for input.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequest
 */
export interface RequestCatalogManagementServiceDeleteRequest {
    /**
     * The Id of the RequestCatalog to delete.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteResponse
 */
export interface RequestCatalogManagementServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask
 */
export interface RequestCatalogOwnerExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListRequest
 */
export interface RequestCatalogOwnersServiceListRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask expand_mask = 4;
     */
    expandMask?: RequestCatalogOwnerExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwner
 */
export interface RequestCatalogOwner {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnerView
 */
export interface RequestCatalogOwnerView {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogOwner request_catalog_owner = 1;
     */
    requestCatalogOwner?: RequestCatalogOwner;
    /**
     * @generated from protobuf field: string user_path = 2;
     */
    userPath: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListResponse
 */
export interface RequestCatalogOwnersServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogOwnerView list = 1;
     */
    list: RequestCatalogOwnerView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddRequest
 */
export interface RequestCatalogOwnersServiceAddRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1;
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddResponse
 */
export interface RequestCatalogOwnersServiceAddResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1;
     */
    user?: User;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveRequest
 */
export interface RequestCatalogOwnersServiceRemoveRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1;
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveResponse
 */
export interface RequestCatalogOwnersServiceRemoveResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogRef
 */
export interface RequestCatalogRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomationLastRunState
 */
export interface BundleAutomationLastRunState {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_run_at = 1;
     */
    lastRunAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationRunStatus status = 2;
     */
    status: BundleAutomationRunStatus;
    /**
     * @generated from protobuf field: string error_message = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement
 */
export interface BundleAutomationRuleEntitlement {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 1;
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SetBundleAutomationRequest
 */
export interface SetBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1;
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements = 101;
         */
        entitlements: BundleAutomationRuleEntitlement;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool enabled = 2;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: bool create_tasks = 3;
     */
    createTasks: boolean;
    /**
     * @generated from protobuf field: bool disable_circuit_breaker = 4;
     */
    disableCircuitBreaker: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomationRef
 */
export interface BundleAutomationRef {
    /**
     * @generated from protobuf field: string request_catalog_id = 1;
     */
    requestCatalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker
 */
export interface BundleAutomationCircuitBreaker {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationCircuitBreakerState state = 1;
     */
    state: BundleAutomationCircuitBreakerState;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2;
     */
    userRef?: UserRef;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: int64 removed_members_threshold_percentage = 4;
     */
    removedMembersThresholdPercentage: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomation
 */
export interface BundleAutomation {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string request_catalog_id = 2;
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationLastRunState state = 6;
     */
    state?: BundleAutomationLastRunState;
    /**
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements = 101;
         */
        entitlements: BundleAutomationRuleEntitlement;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool enabled = 7;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: bool create_tasks = 8;
     */
    createTasks: boolean;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker circuit_breaker = 9;
     */
    circuitBreaker?: BundleAutomationCircuitBreaker;
    /**
     * @generated from protobuf field: bool disable_circuit_breaker = 10;
     */
    disableCircuitBreaker: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.GetBundleAutomationRequest
 */
export interface GetBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1;
     */
    requestCatalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BulkGetBundleAutomationsRequest
 */
export interface BulkGetBundleAutomationsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogRef request_catalog_refs = 1;
     */
    requestCatalogRefs: RequestCatalogRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BulkGetBundleAutomationsResponse
 */
export interface BulkGetBundleAutomationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.BundleAutomation list = 1;
     */
    list: BundleAutomation[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ForceRunBundleAutomationRequest
 */
export interface ForceRunBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1;
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 2;
     */
    refs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ForceRunBundleAutomationResponse
 */
export interface ForceRunBundleAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ResumePausedBundleAutomationRequest
 */
export interface ResumePausedBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1;
     */
    requestCatalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ResumePausedBundleAutomationResponse
 */
export interface ResumePausedBundleAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.DeleteBundleAutomationRequest
 */
export interface DeleteBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1;
     */
    requestCatalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.DeleteBundleAutomationResponse
 */
export interface DeleteBundleAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CreateBundleAutomationRequest
 */
export interface CreateBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1;
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements = 101;
         */
        entitlements: BundleAutomationRuleEntitlement;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool enabled = 3;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: bool create_tasks = 4;
     */
    createTasks: boolean;
    /**
     * @generated from protobuf field: bool disable_circuit_breaker = 5;
     */
    disableCircuitBreaker: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CreateAppDefaultCatalogRequest
 */
export interface CreateAppDefaultCatalogRequest {
    /**
     * The app id for which this catalog is the default catalog.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * Whether or not the new catalog should be created as published.
     *
     * @generated from protobuf field: bool published = 5;
     */
    published: boolean;
    /**
     * Whether or not the new catalog is visible to everyone by default.
     *
     * @generated from protobuf field: bool visible_to_everyone = 6;
     */
    visibleToEveryone: boolean;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 2;
     */
    expandMask?: RequestCatalogExpandMask;
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.BundleAutomationRunStatus
 */
export enum BundleAutomationRunStatus {
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_FAILURE = 2;
     */
    FAILURE = 2,
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_IN_PROGRESS = 3;
     */
    IN_PROGRESS = 3,
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_WAITING_FOR_APPROVAL = 4;
     */
    WAITING_FOR_APPROVAL = 4
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.BundleAutomationCircuitBreakerState
 */
export enum BundleAutomationCircuitBreakerState {
    /**
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_UNSPECIFIED = 0;
     */
    CIRCUIT_BREAKER_STATE_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_TRIGGERED = 1;
     */
    CIRCUIT_BREAKER_STATE_TRIGGERED = 1,
    /**
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_BYPASS = 2;
     */
    CIRCUIT_BREAKER_STATE_BYPASS = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceGetRequest$Type extends MessageType<RequestCatalogManagementServiceGetRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequest
 */
export const RequestCatalogManagementServiceGetRequest = new RequestCatalogManagementServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceGetResponse$Type extends MessageType<RequestCatalogManagementServiceGetResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetResponse", [
            { no: 1, name: "request_catalog_view", kind: "message", T: () => RequestCatalogView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetResponse
 */
export const RequestCatalogManagementServiceGetResponse = new RequestCatalogManagementServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceCreateRequest$Type extends MessageType<RequestCatalogManagementServiceCreateRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask },
            { no: 5, name: "published", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "request_bundle", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "enrollment_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior", RequestCatalogEnrollmentBehavior, "REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_"] },
            { no: 9, name: "unenrollment_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior", RequestCatalogUnenrollmentBehavior, "REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_"] },
            { no: 10, name: "unenrollment_entitlement_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior", RequestCatalogUnenrollmentEntitlementBehavior, "REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_"] }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequest
 */
export const RequestCatalogManagementServiceCreateRequest = new RequestCatalogManagementServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceUpdateRequest$Type extends MessageType<RequestCatalogManagementServiceUpdateRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateRequest", [
            { no: 1, name: "catalog", kind: "message", T: () => RequestCatalog, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateRequest
 */
export const RequestCatalogManagementServiceUpdateRequest = new RequestCatalogManagementServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListRequest$Type extends MessageType<RequestCatalogManagementServiceListRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListRequest
 */
export const RequestCatalogManagementServiceListRequest = new RequestCatalogManagementServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListResponse$Type extends MessageType<RequestCatalogManagementServiceListResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListResponse
 */
export const RequestCatalogManagementServiceListResponse = new RequestCatalogManagementServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceAddAppEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceAddAppEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "create_requests", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entries" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsRequest
 */
export const RequestCatalogManagementServiceAddAppEntitlementsRequest = new RequestCatalogManagementServiceAddAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceAddAppEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceAddAppEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsResponse
 */
export const RequestCatalogManagementServiceAddAppEntitlementsResponse = new RequestCatalogManagementServiceAddAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceUpdateAppEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceUpdateAppEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entries" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsRequest
 */
export const RequestCatalogManagementServiceUpdateAppEntitlementsRequest = new RequestCatalogManagementServiceUpdateAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceUpdateAppEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceUpdateAppEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsResponse
 */
export const RequestCatalogManagementServiceUpdateAppEntitlementsResponse = new RequestCatalogManagementServiceUpdateAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceRemoveAppEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceRemoveAppEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entries" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsRequest
 */
export const RequestCatalogManagementServiceRemoveAppEntitlementsRequest = new RequestCatalogManagementServiceRemoveAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceRemoveAppEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceRemoveAppEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsResponse
 */
export const RequestCatalogManagementServiceRemoveAppEntitlementsResponse = new RequestCatalogManagementServiceRemoveAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceCreateRequestableEntryRequest$Type extends MessageType<RequestCatalogManagementServiceCreateRequestableEntryRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 4, name: "create_requests", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entry" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryRequest
 */
export const RequestCatalogManagementServiceCreateRequestableEntryRequest = new RequestCatalogManagementServiceCreateRequestableEntryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestableEntry$Type extends MessageType<RequestableEntry> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestableEntry", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestableEntry
 */
export const RequestableEntry = new RequestableEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceCreateRequestableEntryResponse$Type extends MessageType<RequestCatalogManagementServiceCreateRequestableEntryResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryResponse", [
            { no: 1, name: "requestable_entry", kind: "message", T: () => RequestableEntry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryResponse
 */
export const RequestCatalogManagementServiceCreateRequestableEntryResponse = new RequestCatalogManagementServiceCreateRequestableEntryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceGetRequestableEntryRequest$Type extends MessageType<RequestCatalogManagementServiceGetRequestableEntryRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entry" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryRequest
 */
export const RequestCatalogManagementServiceGetRequestableEntryRequest = new RequestCatalogManagementServiceGetRequestableEntryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceGetRequestableEntryResponse$Type extends MessageType<RequestCatalogManagementServiceGetRequestableEntryResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryResponse", [
            { no: 1, name: "requestable_entry", kind: "message", T: () => RequestableEntry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryResponse
 */
export const RequestCatalogManagementServiceGetRequestableEntryResponse = new RequestCatalogManagementServiceGetRequestableEntryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceDeleteRequestableEntryRequest$Type extends MessageType<RequestCatalogManagementServiceDeleteRequestableEntryRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entry" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryRequest
 */
export const RequestCatalogManagementServiceDeleteRequestableEntryRequest = new RequestCatalogManagementServiceDeleteRequestableEntryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceDeleteRequestableEntryResponse$Type extends MessageType<RequestCatalogManagementServiceDeleteRequestableEntryResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryResponse
 */
export const RequestCatalogManagementServiceDeleteRequestableEntryResponse = new RequestCatalogManagementServiceDeleteRequestableEntryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceAddAccessEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceAddAccessEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Visibility_Bindings" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsRequest
 */
export const RequestCatalogManagementServiceAddAccessEntitlementsRequest = new RequestCatalogManagementServiceAddAccessEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceAddAccessEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceAddAccessEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsResponse
 */
export const RequestCatalogManagementServiceAddAccessEntitlementsResponse = new RequestCatalogManagementServiceAddAccessEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceRemoveAccessEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceRemoveAccessEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Visibility_Bindings" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsRequest
 */
export const RequestCatalogManagementServiceRemoveAccessEntitlementsRequest = new RequestCatalogManagementServiceRemoveAccessEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceRemoveAccessEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceRemoveAccessEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsResponse
 */
export const RequestCatalogManagementServiceRemoveAccessEntitlementsResponse = new RequestCatalogManagementServiceRemoveAccessEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsPerCatalogRequest$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsPerCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogRequest
 */
export const RequestCatalogManagementServiceListEntitlementsPerCatalogRequest = new RequestCatalogManagementServiceListEntitlementsPerCatalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsPerCatalogResponse$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsPerCatalogResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogResponse
 */
export const RequestCatalogManagementServiceListEntitlementsPerCatalogResponse = new RequestCatalogManagementServiceListEntitlementsPerCatalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest$Type extends MessageType<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest
 */
export const RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest = new RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse$Type extends MessageType<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse
 */
export const RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse = new RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsPerAppRequest$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppRequest
 */
export const RequestCatalogManagementServiceListEntitlementsPerAppRequest = new RequestCatalogManagementServiceListEntitlementsPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsPerAppResponse$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppResponse
 */
export const RequestCatalogManagementServiceListEntitlementsPerAppResponse = new RequestCatalogManagementServiceListEntitlementsPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsForAccessRequest$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsForAccessRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessRequest
 */
export const RequestCatalogManagementServiceListEntitlementsForAccessRequest = new RequestCatalogManagementServiceListEntitlementsForAccessRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsForAccessResponse$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsForAccessResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessResponse
 */
export const RequestCatalogManagementServiceListEntitlementsForAccessResponse = new RequestCatalogManagementServiceListEntitlementsForAccessResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceDeleteRequest$Type extends MessageType<RequestCatalogManagementServiceDeleteRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequest
 */
export const RequestCatalogManagementServiceDeleteRequest = new RequestCatalogManagementServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceDeleteResponse$Type extends MessageType<RequestCatalogManagementServiceDeleteResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteResponse
 */
export const RequestCatalogManagementServiceDeleteResponse = new RequestCatalogManagementServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnerExpandMask$Type extends MessageType<RequestCatalogOwnerExpandMask> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask
 */
export const RequestCatalogOwnerExpandMask = new RequestCatalogOwnerExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceListRequest$Type extends MessageType<RequestCatalogOwnersServiceListRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => RequestCatalogOwnerExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListRequest
 */
export const RequestCatalogOwnersServiceListRequest = new RequestCatalogOwnersServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwner$Type extends MessageType<RequestCatalogOwner> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwner", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwner
 */
export const RequestCatalogOwner = new RequestCatalogOwner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnerView$Type extends MessageType<RequestCatalogOwnerView> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnerView", [
            { no: 1, name: "request_catalog_owner", kind: "message", T: () => RequestCatalogOwner },
            { no: 2, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnerView
 */
export const RequestCatalogOwnerView = new RequestCatalogOwnerView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceListResponse$Type extends MessageType<RequestCatalogOwnersServiceListResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogOwnerView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListResponse
 */
export const RequestCatalogOwnersServiceListResponse = new RequestCatalogOwnersServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceAddRequest$Type extends MessageType<RequestCatalogOwnersServiceAddRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddRequest
 */
export const RequestCatalogOwnersServiceAddRequest = new RequestCatalogOwnersServiceAddRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceAddResponse$Type extends MessageType<RequestCatalogOwnersServiceAddResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddResponse", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddResponse
 */
export const RequestCatalogOwnersServiceAddResponse = new RequestCatalogOwnersServiceAddResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceRemoveRequest$Type extends MessageType<RequestCatalogOwnersServiceRemoveRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveRequest
 */
export const RequestCatalogOwnersServiceRemoveRequest = new RequestCatalogOwnersServiceRemoveRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceRemoveResponse$Type extends MessageType<RequestCatalogOwnersServiceRemoveResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveResponse
 */
export const RequestCatalogOwnersServiceRemoveResponse = new RequestCatalogOwnersServiceRemoveResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogRef$Type extends MessageType<RequestCatalogRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogRef
 */
export const RequestCatalogRef = new RequestCatalogRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomationLastRunState$Type extends MessageType<BundleAutomationLastRunState> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomationLastRunState", [
            { no: 1, name: "last_run_at", kind: "message", T: () => Timestamp },
            { no: 2, name: "status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.BundleAutomationRunStatus", BundleAutomationRunStatus, "BUNDLE_AUTOMATION_RUN_STATUS_"] },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomationLastRunState
 */
export const BundleAutomationLastRunState = new BundleAutomationLastRunState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomationRuleEntitlement$Type extends MessageType<BundleAutomationRuleEntitlement> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement", [
            { no: 1, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement
 */
export const BundleAutomationRuleEntitlement = new BundleAutomationRuleEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBundleAutomationRequest$Type extends MessageType<SetBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SetBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => BundleAutomationRuleEntitlement },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "create_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "disable_circuit_breaker", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SetBundleAutomationRequest
 */
export const SetBundleAutomationRequest = new SetBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomationRef$Type extends MessageType<BundleAutomationRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomationRef", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomationRef
 */
export const BundleAutomationRef = new BundleAutomationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomationCircuitBreaker$Type extends MessageType<BundleAutomationCircuitBreaker> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker", [
            { no: 1, name: "state", kind: "enum", T: () => ["c1.api.requestcatalog.v1.BundleAutomationCircuitBreakerState", BundleAutomationCircuitBreakerState] },
            { no: 2, name: "user_ref", kind: "message", T: () => UserRef },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "removed_members_threshold_percentage", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker
 */
export const BundleAutomationCircuitBreaker = new BundleAutomationCircuitBreaker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomation$Type extends MessageType<BundleAutomation> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomation", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "state", kind: "message", T: () => BundleAutomationLastRunState },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => BundleAutomationRuleEntitlement },
            { no: 7, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "create_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "circuit_breaker", kind: "message", T: () => BundleAutomationCircuitBreaker },
            { no: 10, name: "disable_circuit_breaker", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomation
 */
export const BundleAutomation = new BundleAutomation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBundleAutomationRequest$Type extends MessageType<GetBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.GetBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.GetBundleAutomationRequest
 */
export const GetBundleAutomationRequest = new GetBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetBundleAutomationsRequest$Type extends MessageType<BulkGetBundleAutomationsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.BulkGetBundleAutomationsRequest", [
            { no: 1, name: "request_catalog_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BulkGetBundleAutomationsRequest
 */
export const BulkGetBundleAutomationsRequest = new BulkGetBundleAutomationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetBundleAutomationsResponse$Type extends MessageType<BulkGetBundleAutomationsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.BulkGetBundleAutomationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BundleAutomation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BulkGetBundleAutomationsResponse
 */
export const BulkGetBundleAutomationsResponse = new BulkGetBundleAutomationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceRunBundleAutomationRequest$Type extends MessageType<ForceRunBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.ForceRunBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ForceRunBundleAutomationRequest
 */
export const ForceRunBundleAutomationRequest = new ForceRunBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceRunBundleAutomationResponse$Type extends MessageType<ForceRunBundleAutomationResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.ForceRunBundleAutomationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ForceRunBundleAutomationResponse
 */
export const ForceRunBundleAutomationResponse = new ForceRunBundleAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResumePausedBundleAutomationRequest$Type extends MessageType<ResumePausedBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.ResumePausedBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ResumePausedBundleAutomationRequest
 */
export const ResumePausedBundleAutomationRequest = new ResumePausedBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResumePausedBundleAutomationResponse$Type extends MessageType<ResumePausedBundleAutomationResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.ResumePausedBundleAutomationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ResumePausedBundleAutomationResponse
 */
export const ResumePausedBundleAutomationResponse = new ResumePausedBundleAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBundleAutomationRequest$Type extends MessageType<DeleteBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.DeleteBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.DeleteBundleAutomationRequest
 */
export const DeleteBundleAutomationRequest = new DeleteBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBundleAutomationResponse$Type extends MessageType<DeleteBundleAutomationResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.DeleteBundleAutomationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.DeleteBundleAutomationResponse
 */
export const DeleteBundleAutomationResponse = new DeleteBundleAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBundleAutomationRequest$Type extends MessageType<CreateBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.CreateBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => BundleAutomationRuleEntitlement },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "create_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "disable_circuit_breaker", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CreateBundleAutomationRequest
 */
export const CreateBundleAutomationRequest = new CreateBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppDefaultCatalogRequest$Type extends MessageType<CreateAppDefaultCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.CreateAppDefaultCatalogRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "published", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CreateAppDefaultCatalogRequest
 */
export const CreateAppDefaultCatalogRequest = new CreateAppDefaultCatalogRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.requestcatalog.v1.RequestCatalogManagementService
 */
export const RequestCatalogManagementService = new ServiceType("c1.api.requestcatalog.v1.RequestCatalogManagementService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access_Profile" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceGetRequest, O: RequestCatalogManagementServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Profile" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceCreateRequest, O: RequestCatalogManagementServiceGetResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{catalog.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access_Profile" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceUpdateRequest, O: RequestCatalogManagementServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Request Catalogs", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceListRequest, O: RequestCatalogManagementServiceListResponse },
    { name: "AddAppEntitlements", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{catalog_id}/requestable_entries", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Profile_Requestable_Entries" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceAddAppEntitlementsRequest, O: RequestCatalogManagementServiceAddAppEntitlementsResponse },
    { name: "RemoveAppEntitlements", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{catalog_id}/requestable_entries", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Profile_Requestable_Entries" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceRemoveAppEntitlementsRequest, O: RequestCatalogManagementServiceRemoveAppEntitlementsResponse },
    { name: "CreateRequestableEntry", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/catalogs/{catalog_id}/requestable_entries/{app_id}/{entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Profile_Requestable_Entry" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceCreateRequestableEntryRequest, O: RequestCatalogManagementServiceCreateRequestableEntryResponse },
    { name: "GetRequestableEntry", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{catalog_id}/requestable_entries/{app_id}/{entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access_Profile_Requestable_Entry", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceGetRequestableEntryRequest, O: RequestCatalogManagementServiceGetRequestableEntryResponse },
    { name: "DeleteRequestableEntry", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{catalog_id}/requestable_entries/{app_id}/{entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Profile_Requestable_Entry" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceDeleteRequestableEntryRequest, O: RequestCatalogManagementServiceDeleteRequestableEntryResponse },
    { name: "AddAccessEntitlements", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{catalog_id}/visibility_bindings", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Profile_Visibility_Bindings" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceAddAccessEntitlementsRequest, O: RequestCatalogManagementServiceAddAccessEntitlementsResponse },
    { name: "RemoveAccessEntitlements", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{catalog_id}/visibility_bindings", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Profile_Visibility_Bindings" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceRemoveAccessEntitlementsRequest, O: RequestCatalogManagementServiceRemoveAccessEntitlementsResponse },
    { name: "ListEntitlementsPerCatalog", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{catalog_id}/requestable_entitlements", query: { page_size: "page_size", page_token: "page_token" }, group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceListEntitlementsPerCatalogRequest, O: RequestCatalogManagementServiceListEntitlementsPerCatalogResponse },
    { name: "ListEntitlementsPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceListEntitlementsPerAppRequest, O: RequestCatalogManagementServiceListEntitlementsPerAppResponse },
    { name: "ListAllEntitlementIdsPerApp", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{catalog_id}/requestable_entitlementIDs", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access_Profile_Requestable_Entries", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest, O: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse },
    { name: "UpdateAppEntitlements", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{catalog_id}/requestable_entitlements/update", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access_Profile_Requestable_Entries" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceUpdateAppEntitlementsRequest, O: RequestCatalogManagementServiceUpdateAppEntitlementsResponse },
    { name: "ListEntitlementsForAccess", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{catalog_id}/visibility_entitlements", query: { page_size: "page_size", page_token: "page_token" }, group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceListEntitlementsForAccessRequest, O: RequestCatalogManagementServiceListEntitlementsForAccessResponse },
    { name: "Delete", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Profile" }], group: "Request Catalog" }] } }, I: RequestCatalogManagementServiceDeleteRequest, O: RequestCatalogManagementServiceDeleteResponse },
    { name: "GetBundleAutomation", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "BundleAutomation" }], group: "Request Catalog" }] } }, I: GetBundleAutomationRequest, O: BundleAutomation },
    { name: "BulkGetBundleAutomations", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetBundleAutomationsRequest, O: BulkGetBundleAutomationsResponse },
    { name: "SetBundleAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "BundleAutomation" }], group: "Request Catalog" }] } }, I: SetBundleAutomationRequest, O: BundleAutomation },
    { name: "ForceRunBundleAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation/run", group: "Request Catalog" }] } }, I: ForceRunBundleAutomationRequest, O: ForceRunBundleAutomationResponse },
    { name: "ResumePausedBundleAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation/resume", group: "Request Catalog" }] } }, I: ResumePausedBundleAutomationRequest, O: ResumePausedBundleAutomationResponse },
    { name: "CreateBundleAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation/create", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "BundleAutomation" }], group: "Request Catalog" }] } }, I: CreateBundleAutomationRequest, O: BundleAutomation },
    { name: "DeleteBundleAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "BundleAutomation" }], group: "Request Catalog" }] } }, I: DeleteBundleAutomationRequest, O: DeleteBundleAutomationResponse },
    { name: "CreateAppDefaultCatalog", options: { "authz.method": { role: "VIEWER" } }, I: CreateAppDefaultCatalogRequest, O: RequestCatalogManagementServiceGetResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.requestcatalog.v1.RequestCatalogOwnersService
 */
export const RequestCatalogOwnersService = new ServiceType("c1.api.requestcatalog.v1.RequestCatalogOwnersService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogOwnersServiceListRequest, O: RequestCatalogOwnersServiceListResponse },
    { name: "Add", options: { "authz.method": { role: "EDITOR" } }, I: RequestCatalogOwnersServiceAddRequest, O: RequestCatalogOwnersServiceAddResponse },
    { name: "Remove", options: { "authz.method": { role: "EDITOR" } }, I: RequestCatalogOwnersServiceRemoveRequest, O: RequestCatalogOwnersServiceRemoveResponse }
]);
